const reports = {
  main: {
    btn: 'Abrir'
  },
  filterForm: {
    filter: 'Filtrar',
    export: 'Exportar',
    validation: {
      reportTypeRequired: 'El tipo de informe es obligatorio',
      startDateRequired: 'La fecha de inicio es obligatoria',
      endDateRequired: 'La fecha de finalización es obligatoria',
    },
    form: {
      reportType: {
        label: 'Tipo de informe',
        reportTypeOptions: {
          selectReport: 'Seleccionar informe',
          shuttlePassangers: 'Pasajeros del Shuttle',
          dailySummary: 'Resumen diario',
          delaysReport: 'Informe de Retrasos',
          shuttleReport: 'Informe del Shuttle',
          vehicleOccupancy: 'Ocupación de vehículos',
          commuterSatisfaction: 'La satisfacción del pasajero',
          passengerCostPareto: 'Coste de pasajeros - PARETO',
          carbonEfficiency: 'Eficiencia de Carbono',
          totalTripsPassengers: ' Total de Expediciones / Pasajeros',
        },
      },
      selectShuttle: 'Seleccionar Shuttle',
      dateStart: 'Fecha de inicio',
      dateEnd: 'Fecha de finalización',
    },
  },
};

export default reports;
